// Bundle cart remove: handles the "Remove" button on bundle-cart-group elements.
// Loaded via <script src> from snippets/cart-products.liquid so the listener is
// attached on initial page load, then catches clicks on bundle groups that may
// later be inserted into the cart (drawer or page) via section morphing.

(function () {
  if (window.bundleRemoveListenerAttached) return;
  window.bundleRemoveListenerAttached = true;

  const REMOVE_BTN_HTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
    '<polyline points="3 6 5 6 21 6"></polyline>' +
    '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
    '</svg> Remove';

  const REMOVING_BTN_HTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;">' +
    '<circle cx="12" cy="12" r="10"></circle>' +
    '<path d="M12 6v6l4 2"></path>' +
    '</svg> Removing...';

  function showBundleRemoveError(msg) {
    const toast = document.createElement('div');
    toast.setAttribute('role', 'alert');
    toast.textContent = msg;
    toast.style.cssText =
      'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#c00;color:#fff;padding:12px 20px;border-radius:6px;z-index:9999;max-width:400px;font-size:14px;box-shadow:0 4px 12px rgb(0 0 0 / 0.2);';
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 4000);
  }

  function resetRemoveBtn(btn) {
    btn.dataset.loading = 'false';
    btn.innerHTML = REMOVE_BTN_HTML;
  }

  function collectCartSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function dispatchCartUpdate(responseData, sections) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: responseData,
          sourceId: 'bundle-cart-group',
          data: {
            source: 'bundle-cart-group',
            itemCount: responseData.item_count,
            sections: sections || {},
          },
        },
      })
    );
  }

  document.addEventListener('click', async function (e) {
    const removeBtn = e.target.closest('[data-remove-bundle]');
    if (!removeBtn) return;

    e.preventDefault();
    if (removeBtn.dataset.loading === 'true') return;

    const bundleGroup = removeBtn.closest('.cart--bundle-group');
    if (!bundleGroup || !bundleGroup.dataset.bundleItems) return;

    const itemKeys = bundleGroup.dataset.bundleItems.split(',').filter(Boolean);
    if (itemKeys.length === 0) return;

    removeBtn.dataset.loading = 'true';
    removeBtn.innerHTML = REMOVING_BTN_HTML;

    let previousItemCount = null;
    try {
      const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
      if (cartRes.ok) {
        const cart = await cartRes.json();
        previousItemCount = cart.item_count;
      }
    } catch (_) {
      // Non-fatal: we'll skip the drop verification if we can't read it
    }

    try {
      const updates = {};
      itemKeys.forEach((key) => {
        updates[key] = 0;
      });

      const sectionIds = collectCartSectionIds();

      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
          sections: sectionIds.join(','),
        }),
      });

      if (!response.ok) throw new Error('Cart update failed: ' + response.status);

      const responseData = await response.json();

      // cart/update.js returns 200 OK even when keys don't match any line.
      // Verify the cart actually shrunk by the expected amount; if not, fall
      // back to a fresh server render so the UI matches reality.
      const expectedDrop = itemKeys.length;
      const actualDrop =
        previousItemCount != null ? previousItemCount - responseData.item_count : expectedDrop;

      if (actualDrop < expectedDrop) {
        console.warn('Bundle remove: cart did not shrink as expected', {
          bundleId: removeBtn.dataset.removeBundle,
          itemKeys,
          expectedDrop,
          actualDrop,
          previousItemCount,
          newItemCount: responseData.item_count,
        });
        // Empty sections triggers component-cart-items.js's
        // sectionRenderer.renderSection fallback for a fresh server HTML fetch.
        dispatchCartUpdate(responseData, {});
        return;
      }

      dispatchCartUpdate(responseData, responseData.sections || {});
    } catch (error) {
      console.error('Bundle remove failed:', error, {
        bundleId: removeBtn.dataset.removeBundle,
        itemKeys,
      });
      showBundleRemoveError(
        'Could not remove bundle: ' + (error.message || 'Please try again.')
      );
      resetRemoveBtn(removeBtn);
    }
  });
})();
